module.exports = __webpack_public_path__ + "Medycyna_spersonalizowana_z_pudelkami_v3.jpg?e7cfacdc088c69dea74a8ba3342df04e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Medycyna_spersonalizowana_z_pudelkami_v3.jpg
// module id = 260
// module chunks = 0